export default "__VITE_ASSET__vtdssUK1__"